import React from 'react';

import FooterNavColumn from './FooterNavColumn';

import { content } from './content';

const FooterNav = () => (
    <>
        <FooterNavColumn eventId="footer-ackee" content={content.ackee} />
        <FooterNavColumn eventId="footer-services" content={content.services} />
    </>
);

export default FooterNav;
